<template>
  <nav
    v-if="totalPages > 1"
    class="v2-pagination"
  >
    <button
      class="v2-pagination__btn"
      :disabled="currentPage <= 1"
      @click="$emit('page-change', currentPage - 1)"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="15 18 9 12 15 6" />
      </svg>
    </button>
    <button
      v-for="page in visiblePages"
      :key="page"
      class="v2-pagination__btn"
      :class="{ 'v2-pagination__btn--active': page === currentPage, 'v2-pagination__btn--ellipsis': page === '...' }"
      :disabled="page === '...'"
      @click="page !== '...' && $emit('page-change', page)"
    >
      {{ page }}
    </button>
    <button
      class="v2-pagination__btn"
      :disabled="currentPage >= totalPages"
      @click="$emit('page-change', currentPage + 1)"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <polyline points="9 18 15 12 9 6" />
      </svg>
    </button>
  </nav>
</template>

<script>
export default {
  name: 'V2Pagination',
  props: {
    currentPage: { type: Number, required: true },
    totalItems: { type: Number, required: true },
    perPage: { type: Number, default: 10 },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.perPage)
    },
    visiblePages() {
      const total = this.totalPages
      const current = this.currentPage
      const pages = []

      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push(i)
        return pages
      }

      pages.push(1)

      if (current > 3) {
        pages.push('...')
      }

      const start = Math.max(2, current - 1)
      const end = Math.min(total - 1, current + 1)

      for (let i = start; i <= end; i++) {
        pages.push(i)
      }

      if (current < total - 2) {
        pages.push('...')
      }

      pages.push(total)

      return pages
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--v2-space-1);
  padding: var(--v2-space-4) 0;

  &__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 2rem;
    height: 2rem;
    padding: 0 var(--v2-space-2);
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--v2-foreground);
    background: transparent;
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-md);
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover:not(:disabled):not(.v2-pagination__btn--active) {
      background: var(--v2-muted);
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    &--active {
      background: var(--v2-primary);
      color: var(--v2-primary-foreground);
      border-color: var(--v2-primary);
    }

    &--ellipsis {
      border: none;
      cursor: default;
      &:hover { background: transparent; }
    }
  }
}
</style>
